// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as $$String from "rescript/lib/es6/string.js";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Store$LiveRoom from "../Store.bs.js";
import * as Typewriter$LiveRoom from "./typewriter/Typewriter.bs.js";
import * as Translations$LiveRoom from "../../../translations/Translations.bs.js";
import * as Utils_Analytics$LiveRoom from "../Utils/Utils_Analytics.bs.js";

var initialState = {
  customerId: undefined,
  auth0Id: undefined,
  preferredMemberFlag: undefined,
  clientLevel: undefined,
  isAnalyticsDisabled: false
};

var StoreConfig = {
  initialState: initialState
};

var InternalStore = Store$LiveRoom.MakeStore(StoreConfig);

function initialize(language) {
  Typewriter$LiveRoom.init(false, Utils_Analytics$LiveRoom.languageToAnalytics(language), undefined);
}

function getLotNr(lotNr) {
  var s = Belt_Option.getWithDefault(Belt_Option.map(lotNr, (function (x) {
              return String(x);
            })), "");
  var match = s.length;
  switch (match) {
    case 0 :
        return "0000";
    case 1 :
        return "000" + s;
    case 2 :
        return "00" + s;
    case 3 :
        return "0" + s;
    default:
      return s;
  }
}

function formatDepartmentCategory(departmentCategory) {
  if (Belt_List.length(departmentCategory) > 0) {
    return $$String.concat(" | ", departmentCategory);
  }
  
}

function disableAnalytics(param) {
  var init = Curry._1(InternalStore.getState, undefined);
  Curry._1(InternalStore.update, {
        customerId: init.customerId,
        auth0Id: init.auth0Id,
        preferredMemberFlag: init.preferredMemberFlag,
        clientLevel: init.clientLevel,
        isAnalyticsDisabled: true
      });
}

function enableAnalytics(param) {
  var language = Translations$LiveRoom.getLanguage(undefined);
  initialize(language);
  var init = Curry._1(InternalStore.getState, undefined);
  Curry._1(InternalStore.update, {
        customerId: init.customerId,
        auth0Id: init.auth0Id,
        preferredMemberFlag: init.preferredMemberFlag,
        clientLevel: init.clientLevel,
        isAnalyticsDisabled: false
      });
}

function bidPlaced(bidValue, bidResult, auctionId, auctionName, departmentNames, currency, sapAuctionSaleNumber, lotVikingId, lotNr, lotName, bidType) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  } else {
    Typewriter$LiveRoom.bidPlaced(bidValue, Belt_Option.getWithDefault(currency, ""), bidResult, Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).auth0Id, Curry._1(InternalStore.getState, undefined).preferredMemberFlag, Curry._1(InternalStore.getState, undefined).clientLevel, sapAuctionSaleNumber, Belt_Option.getWithDefault(sapAuctionSaleNumber, "") + getLotNr(lotNr), lotVikingId, lotName, auctionId, auctionName, formatDepartmentCategory(departmentNames), bidType);
    return ;
  }
}

function auctionRoomEntered(auctionId, auctionName, sapAuctionSaleNumber, participantType) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  } else {
    Typewriter$LiveRoom.auctionRoomEntered(sapAuctionSaleNumber, auctionName, auctionId, participantType, Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).auth0Id, Curry._1(InternalStore.getState, undefined).preferredMemberFlag);
    return ;
  }
}

function loginToBid(sapAuctionSaleNumber, departmentNames, auctionId, auctionName, lotId, lotTitle, lotNr) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  } else {
    Typewriter$LiveRoom.loginToBid(sapAuctionSaleNumber, Belt_Option.getWithDefault(sapAuctionSaleNumber, "") + getLotNr(lotNr), lotId, lotTitle, auctionId, auctionName, formatDepartmentCategory(departmentNames));
    return ;
  }
}

function auctionRoomInteraction(me, biddingInteractionType) {
  var match = Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled;
  var match$1 = me.authToken;
  if (match) {
    return ;
  }
  if (typeof match$1 === "object" && match$1.NAME === "Authenticated") {
    if (me.transactional) {
      return Typewriter$LiveRoom.auctionRoomInteraction("Bidder", biddingInteractionType, Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).auth0Id, Curry._1(InternalStore.getState, undefined).preferredMemberFlag);
    } else {
      return Typewriter$LiveRoom.auctionRoomInteraction("Watcher", biddingInteractionType, Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).auth0Id, Curry._1(InternalStore.getState, undefined).preferredMemberFlag);
    }
  }
  Typewriter$LiveRoom.auctionRoomInteraction("Watcher", biddingInteractionType, Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).auth0Id, Curry._1(InternalStore.getState, undefined).preferredMemberFlag);
}

function audioStreamingToggle(audioStreamingToggleTo, auctionId, auctionName, sapAuctionSaleNumber, audioStreamToggle) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  } else {
    Typewriter$LiveRoom.audioStreamingToggle(audioStreamingToggleTo, auctionId, auctionName, sapAuctionSaleNumber, audioStreamToggle);
    return ;
  }
}

function actionNeededPendingEnrollmentViewed(saleId, lotNr, bidMethod, intendedBidAmount, intendedBidCurrency, messageType) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  }
  var match = bidMethod === "LiveAdvance" || bidMethod === "LiveAbsentee" || bidMethod === "LiveRoom" ? [
      Belt_Option.getWithDefault(saleId, "") + getLotNr(lotNr),
      intendedBidAmount,
      intendedBidCurrency
    ] : [
      undefined,
      undefined,
      undefined
    ];
  Typewriter$LiveRoom.registrationPendingMessageViewed(saleId, match[0], messageType, bidMethod, Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).auth0Id, Curry._1(InternalStore.getState, undefined).preferredMemberFlag, match[1], match[2]);
}

function currencySelected(auctionCurrency, currencyNew, sapAuctionSaleNumber, currencySelectionOrigin) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  } else {
    Typewriter$LiveRoom.currencySelected(currencyNew, sapAuctionSaleNumber, currencySelectionOrigin, auctionCurrency);
    return ;
  }
}

function notAllowedToBid(sapAuctionSaleNumber, messageType) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  } else {
    Typewriter$LiveRoom.notAllowedToBid(Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).preferredMemberFlag, messageType, Belt_Option.getWithDefault(sapAuctionSaleNumber, ""));
    return ;
  }
}

function auctionRegistrationCompleted(auctionSaleNumber, bidMethod, productIdList, numProducts, auctionRestriction, enrollmentStatus, auctionRegistrationOrigin, userId, accountId, auctionId, auctionType, paddleId) {
  if (Curry._1(InternalStore.getState, undefined).isAnalyticsDisabled) {
    return ;
  }
  var match = Belt_Option.map(auctionRestriction, Utils_Analytics$LiveRoom.isDateAfterNow);
  Typewriter$LiveRoom.auctionRegistrationCompleted(auctionSaleNumber, "Web", bidMethod, Curry._1(InternalStore.getState, undefined).customerId, Curry._1(InternalStore.getState, undefined).auth0Id, Curry._1(InternalStore.getState, undefined).preferredMemberFlag, productIdList, numProducts, Belt_Option.isSome(auctionRestriction), Belt_Option.map(auctionRestriction, Utils_Analytics$LiveRoom.isDateAfterNow), match !== undefined && match ? enrollmentStatus : undefined, auctionRegistrationOrigin, userId, accountId, auctionId, auctionType, paddleId);
}

export {
  StoreConfig ,
  initialState ,
  InternalStore ,
  initialize ,
  getLotNr ,
  formatDepartmentCategory ,
  disableAnalytics ,
  enableAnalytics ,
  bidPlaced ,
  auctionRoomEntered ,
  loginToBid ,
  auctionRoomInteraction ,
  audioStreamingToggle ,
  actionNeededPendingEnrollmentViewed ,
  currencySelected ,
  notAllowedToBid ,
  auctionRegistrationCompleted ,
}
/* InternalStore Not a pure module */
